import { DATE_FORMATS, DateTime } from "@bps/date-time";
import { Heading, Link, Stack, Text } from "@bps/fluent-ui";
import { XeroFinancialSyncData } from "@libs/gateways/custom-integration/CustomIntegrationXeroGateway.dtos.ts";
import { capitalizeSentence } from "@libs/utils/utils.ts";
import { Navigate } from "@ui-components/navigation/Navigate.tsx";

import {
  getOmniLinkUrl,
  getXeroLinkUrl
} from "./XeroSyncHistoryListItem.utils.ts";

interface XeroSyncHistoryListItemProps {
  data: XeroFinancialSyncData;
}

export const XeroSyncHistoryListItem = ({
  data
}: XeroSyncHistoryListItemProps) => {
  const {
    targetId,
    operationType,
    operationDate,
    changeLog,
    payload,
    status,
    statusDetails,
    sourceEntityId
  } = data;

  const omniUrl = getOmniLinkUrl({ sourceEntityId, operationType });
  const xeroUrl = getXeroLinkUrl({ targetId, operationType });

  return (
    <Stack tokens={{ childrenGap: 4 }}>
      <Heading>
        {operationType} - {capitalizeSentence(status)}
      </Heading>
      <Text>
        {payload.status ? capitalizeSentence(payload.status) : undefined}
      </Text>
      <Text>
        Sync:{" "}
        {DateTime.fromISO(
          changeLog.updatedDate || changeLog.createdDate
        ).toFormat(DATE_FORMATS.LONG_DATE_FORMAT)}
      </Text>
      {payload.items?.length ? (
        <Stack>
          {payload.items.map(item => {
            const date = DateTime.fromISO(operationDate).toFormat(
              DATE_FORMATS.LONG_DATE_TIME_FORMAT
            );

            return (
              <Text key={item.description}>
                {item.description} {date}
              </Text>
            );
          })}
        </Stack>
      ) : undefined}
      {statusDetails.length ? (
        <Stack>
          <Heading>Messages</Heading>
          {statusDetails.map(({ message }) => (
            <Text key={message}>{message}</Text>
          ))}
        </Stack>
      ) : undefined}
      {omniUrl || xeroUrl ? (
        <Stack horizontal tokens={{ childrenGap: 32 }}>
          {omniUrl && <Navigate to={omniUrl}>View in Omni</Navigate>}
          {xeroUrl && (
            <Link href={xeroUrl} target="_blank">
              View in Xero
            </Link>
          )}
        </Stack>
      ) : undefined}
    </Stack>
  );
};
